// extracted by mini-css-extract-plugin
export default {"tableSkeleton":"TableSkeleton_tableSkeleton__N0FpX"};